export enum RecommendationKindEnum {
  RE_ENGAGE = "re_engage",
  STALLED_LEADS = "stalled_leads",
  STALLED_PROJECT = "stalled_project",
  RANK_UP_PUSH = "rank_up_push",
  STALLED_ONBOARDING = "stalled_onboarding",
}

export enum RecommendationStatusEnum {
  ACTIVE = "active",
  COMPLETED = "completed",
  DISMISSED = "dismissed",
  CLEARED = "cleared",
}

export enum RecommendationSubjectTypeEnum {
  USER = "User",
  PROJECT = "ProviderLead",
}
